<!-- 基本信息界面 -->
<template>
  <div style="width: 100%; height: 100%">
    <div
      style="
        width: 0.5376vw;
        height: 100%;
        display: flex;
        float: left;
        background: rgba(240, 240, 240, 1);
      "
    ></div>
    <div style="width: 6%; height: 100%; float: left"></div>
    <div style="width: 93%; height: 100%; float: left">
      <div style="width: 100%; height: 4.5%"></div>
      <div
        style="width: 100%; height: 5.5%; align-items: center; display: flex"
      >
        <div
          style="
            width: 20%;
            height: 100%;
            float: left;
            align-items: center;
            display: flex;
          "
          class="v41_161"
        >
          <span v-if="Lflag == true" class="v35_1047" style="width: 15%"
            >报警</span
          >
          <span v-if="Lflag == false" class="v35_1047" style="width: 15%"
            >Alarm</span
          >
        </div>
      </div>

      <div style="width: 100%; display: flex; float: left">
        <el-container
          style="width: auto; height: auto"
          v-for="item of this.project"
          :key="item.id"
        >
          <el-button
            type="txt"
            @click="enter(item)"
            style="
              width: 25vw;
              height: 27vh;
              background: rgba(243, 249, 255, 1);
            "
          >
            <div>
              <div style="margin-left: 0vw">{{ item }}</div>
              <div
                style="margin-top: 8vh"
                v-for="(it, key) in alarm"
                :key="key"
              >
                <a v-if="Lflag == true">当前报警是：</a>
                <a v-if="Lflag == false">Current Alarm:</a>
                <span v-if="item == key">
                  <span v-if="it">
                    {{ it }}
                  </span>
                </span>
                <span v-else> 0 </span>
              </div>
            </div>
          </el-button>
        </el-container>
      </div>

      <router-link
        to="/Main/Alarm_record"
        class="no-underline"
        style="justify-content: left; align-items: center; display: flex"
      >
      </router-link>
    </div>
    <div style="background: rgba(255, 255, 255, 1)"></div>
  </div>
</template>

<script>
import { checkToken } from "@/api/user"; //将checkToken方法从/api/user导入，作用是发送网络请求

import { FALSE } from "ol/functions";

export default {
  data() {
    return {
      project: "", //用于接收从state里传过来的项目名
      Lflag: true,
      // 地址对象，用于存储选择的省市区信息
      alarm: this.$store.state.alarm,
      site: this.$store.state.site,
      projectNew: "",

      key: 0,
    };
  },
  created() {
    //created里的指令在该组件创建的时候执行，created比mounted更早执行
    //console.log(selectedProjectId)//打印，用于测试
    this.$store.commit("restorename"); //将保存在本地的用户名传给state
    this.$store.commit("restoreproject"); //将保存在本地的项目名传给state
    this.$store.commit("restoretoken"); //将保存在本地的token传给state
    this.$store.commit("restoreAlarm");
    this.Lflag = this.$store.state.Language; //store里的传到该组件
    checkToken(this.$qs.stringify({ token: this.$store.state.token })).then(
      (res) => {
        //发送请求：让后端检查token，后端返回的状态在request的response interceptor里拦截并作出相应的响应
        console.log(res);
      }
    );
  },
  mounted: async function () {
    // 监听主界面的语言切换事件
    this.$bus.$on("language-changed", (flag) => {
      this.Lflag = flag;
    });
    //mounted里的指令在该组件被挂载的时候执行，这里需要加上async，否则可能收不到返回值
    this.project = this.$store.state.project; //将store里的项目名传到本组件
  },
  methods: {
    enter(projectNew) {
      this.projectNew = projectNew;
      console.log(this.projectNew);
      this.$store.commit("setProjectNew", projectNew);
      this.$router.push("/Main/Alarm_record");
    },
  },
  beforeDestroy() {
    // 销毁时移除事件监听，避免内存泄漏
    this.$bus.$off("language-changed");
  },
};
</script>
<style>
.description {
  height: 4.8387vw;
}

.edit {
  top: 53.7634vw;
  right: 5.3763vw;
}

.basic_info {
  resize: none;
  width: 80%;
  height: 2.1505vw;
}

.v41_170 {
  width: 5.1613vw;
  color: rgba(0, 0, 0, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 1.0753vw;
  opacity: 1;
  text-align: left;
}

.v41_172 {
  width: 6.8817vw;
  height: 2.7957vw;
  background: rgba(25, 44, 250, 1);
  padding: 0.5914vw 2.1505vw;
  margin: 0.5376vw;
  opacity: 1;
  border-top-left-radius: 0.2688vw;
  border-top-right-radius: 0.2688vw;
  border-bottom-left-radius: 0.2688vw;
  border-bottom-right-radius: 0.2688vw;
  overflow: hidden;
}

.v41_169 {
  width: 5.1613vw;
  color: rgba(25, 44, 250, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v41_168 {
  width: 2.5806vw;
  color: rgba(255, 255, 255, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  opacity: 1;
  text-align: left;
}

.v41_166 {
  width: 98%;
  height: 100%;
  background: rgba(243, 249, 255, 1);
  outline-color: rgba(243, 249, 255, 1);
  opacity: 1;
  padding: 0vw;
  border: 0vw;
  border-top-left-radius: 0.5376vw;
  border-top-right-radius: 0.5376vw;
  border-bottom-left-radius: 0.5376vw;
  border-bottom-right-radius: 0.5376vw;
  overflow: hidden;
  color: rgba(0, 0, 0, 1);
  font-family: Microsoft YaHei UI;
  font-weight: Regular;
  font-size: 0.8602vw;
  text-align: left;
}

.box-card .text {
  font-size: 0.7527vw;
}

.item {
  margin-bottom: 0.9677vw;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 43.0108vw;
}
</style>
